export default {
  id: "kioskSales",
  name: "",
  description: "",
  report: {
    name: "Kiosk Sales",
    chartType: "COLUMN",
    template: "custom",
    config: {
      dataSet: "Sale",
      dataType: "time_series",
      dimensions: [],
      measures: ["Sale.total_revenue"],
      sort: {
        direction: null,
        by: null,
      },
      timeDimension: "Sale.sale_time",
      timeGranularity: "day",
      filters: [
        {
          member: "Sale.source",
          operator: "equals",
          values: ["6"],
        },
      ],
      compare: true,
      limit: "999",
      rowTotals: false,
      points: false,
      colorTheme: "default",
    },
  },
};
